import { HvlDateConverter } from '@hvlng/framework-bff/util';
import { EmptyControl, Nested, Required } from '@hvlng/framework-bff/core';
import { HvlQueryModel } from '@hvlng/framework-bff/core';
import { JsonObject, JsonProperty } from 'json2typescript';
import { PerObjectDefinitionQueryModel } from './per-object-definition-query-model';

@JsonObject('KovanHrPerObjectDefinitonQueryWithOrganizationDatesModel')
export class PerObjectDefinitonQueryWithOrganizationDatesModel {
    @Nested()
    @JsonProperty('perObjectDefinitonQuery', PerObjectDefinitionQueryModel, true)
    perObjectDefinitonQuery: PerObjectDefinitionQueryModel = new PerObjectDefinitionQueryModel();

    @EmptyControl()
    @JsonProperty('orgBeginDate', HvlDateConverter, true)
    orgBeginDate: Date = null;

    @EmptyControl()
    @JsonProperty('orgEndDate', HvlDateConverter, true)
    orgEndDate: Date = null;

    @EmptyControl()
    @JsonProperty('objectDefinitionCId', Number, true)
    objectDefinitionCId: number = null;

    @EmptyControl()
    @JsonProperty('employeeTypeId', Number, true)
    employeeTypeId: number = null;

    @EmptyControl()
    @JsonProperty('employeeSubtypeId', Number, true)
    employeeSubtypeId: number = null;

    @EmptyControl()
    @JsonProperty('staffClass', String, true)
    staffClass: string = null;
}
